import {
  breakpoints,
  IconRegularOptions,
  theme,
} from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const BackLink = styled.a`
  all: unset;
  cursor: pointer;

  @media (min-width: ${breakpoints.md}) {
    color: ${theme.color.text.secondary};
    display: flex;
    align-items: center;
    gap: 0.4rem;
    &:hover {
      text-decoration: underline;
    }
    margin: 2.5rem 0.5rem 1rem;
    ${theme.typography.labelRegular400}
  }
`;

export const HeaderWrapper = styled.div`
  padding: 1rem 0.5rem 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    margin-inline: 0.75rem;
    cursor: pointer;
    @media (min-width: ${breakpoints.md}) {
      margin-inline: 0;
    }
  }

  @media (min-width: ${breakpoints.md}) {
    justify-content: start;
    gap: 0.5rem;
    padding: 1rem 1rem 0.75rem;

    svg:first-child {
      display: none;
    }
  }
`;

export const HeaderTitle = styled.div`
  ${theme.typography.labelLarge}

  @media (min-width: ${breakpoints.md}) {
    ${theme.typography.titleLarge}
  }
`;

export const EmptyWrapper = styled.div`
  min-height: 65vh;
`;

export const HeaderOptions = styled(IconRegularOptions)`
  height: 1.25rem;
  width: 1.25rem;
  min-width: 1.25rem;

  @media (min-width: ${breakpoints.md}) {
    height: 2.25rem;
    width: 2.25rem;
    padding: 0.5rem;
    border-radius: 100rem;

    &:hover {
      background-color: ${theme.color.background.primaryHover};
    }
  }
`;
